
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'


export default {
name: "detail",
components: {
Tabbar
},
data() {
return {
calendarData: [],
selectStatus: 0, // -1:选择完成,0未选择任何，1:选择了开始时间
selectStartTime: null,
selectEndTime: null,
roomBaseInfo: {}
}
},
created() {
let date = new Date()
let year = date.getFullYear()
let month = date.getMonth()
this.calendarData = this.createcalendarData(year + '-' + month, 3)

this.initPriceForCalender()
this.initRoomBaseInfo()
console.log('created......')
},

beforeCreate(){
console.log('beforeCreate......')
},
beforeMount(){
console.log('beforeMount......')
},
mounted(){
console.log('mounted......')
},
beforeUpdate(){
console.log('beforeUpdate......')
},
activated(){
console.log('activated......')
},
deactivated(){
console.log('deactivated......')
},
beforeDestory(){
console.log('beforeDestory......')
},
destoryed(){
console.log('destoryed......')
},

methods: {
/**
* 构建日历数据
*
* @param startYearMonth 开始年月
* @param step 获取几个月的
* @returns {Array}
*/
createcalendarData: function (startYearMonth, step) {

let rs = [];
var year = parseInt(startYearMonth.split("-")[0]);
var month = parseInt(startYearMonth.split("-")[1]);
var todayDateObj = new Date();
for (let i = 0; i < step; i++) {

let nowMonthDate = new Date(year, month + i, 1);
let firstDay = nowMonthDate.getDay();

let d = new Date(nowMonthDate.getFullYear(), (nowMonthDate.getMonth() + 1), 0);
let maxDay = d.getDate();

let totalWeek = Math.ceil(maxDay / 7);
let daysDesc = [];
let nowYearDesc = nowMonthDate.getFullYear();

let nowMonthDesc = nowMonthDate.getMonth() + 1;
let compareToday = null
for (let j = 1; j <= maxDay; j++) {

let nowDay = new Date(year, month + i, j);
let nowDateObj = new Date(year, month + i, j);
if (nowDateObj.toDateString() == todayDateObj.toDateString()) {
compareToday = 'equal'
} else if (nowDateObj < todayDateObj) {
compareToday = 'less'
} else {
compareToday = 'greater'
}
daysDesc.push({
'price': null,
'flag': null,
'date': nowDay.getDate(),
'day': nowDay.getDay(),
'compareToday': compareToday
})
}

let calendar = {
'year': nowYearDesc,
'month': nowMonthDesc,
'days': daysDesc,
'firstDay': firstDay,
'lastDate': maxDay,
'weeks': totalWeek
}
rs.push(calendar)
}
return rs;
},





/**
* 选择日历事件
*
* @param year
* @param month
* @param date
*/
selectDateEvent: function (year, month, date) {

var todayDateObj = new Date();
var todayYear = todayDateObj.getFullYear()
var todayMonth = todayDateObj.getMonth() + 1
var todayDate = todayDateObj.getDate()
if (new Date(year, month, date).getTime() < new Date(todayYear, todayMonth, todayDate).getTime()) {

return
}
switch (this.selectStatus) {
case -1:
this.selectStartTime = (year + '-' + month + '-' + date);
this.selectEndTime = null;
this.selectStatus = 1;

break;
case 0:
this.selectStartTime = (year + '-' + month + '-' + date);
this.selectStatus = 1;

break;
case 1:


let hadStartTime = this.selectStartTime;
if (hadStartTime == null) {
this.selectEndTime = null;
this.selectStatus = 0;
break;
}

if (this.selectStartTime == (year + '-' + month + '-' + date)) {

} else {
let startYear = hadStartTime.split('-')[0];
let startMonth = hadStartTime.split('-')[1];
let startDate = hadStartTime.split('-')[2];

if (new Date(year, month, date) < new Date(startYear, startMonth, startDate)) {
this.selectStartTime = (year + '-' + month + '-' + date);
this.selectEndTime = null;
this.selectStatus = 1;

break;
}
}

this.selectEndTime = (year + '-' + month + '-' + date);
this.selectStatus = -1;
break;
default:
}
},
/**
* 判断给的日期是否在两个日期之间
*
* @param nowTime
* @param selectStartTime
* @param selectEndTime
* @returns {boolean}
*/
betweenStartEnd(nowTime, selectStartTime, selectEndTime) {
if (selectStartTime == null || selectEndTime == null) {
return false;
}

let startYear = selectStartTime.split('-')[0];
let startMonth = selectStartTime.split('-')[1] - 1;
let startDate = selectStartTime.split('-')[2];

let startTime = (new Date(startYear, startMonth, startDate)) / 1000;

let endYear = selectEndTime.split('-')[0];
let endMonth = selectEndTime.split('-')[1] - 1;
let endDate = selectEndTime.split('-')[2];

let endTime = (new Date(endYear, endMonth, endDate)) / 1000;

let selectYear = nowTime.split('-')[0];
let selectMonth = nowTime.split('-')[1] - 1;
let selectDate = nowTime.split('-')[2];


let selectTime = (new Date(selectYear, selectMonth, selectDate)) / 1000;
if (selectTime > startTime && selectTime < endTime) {

return true;
} else {

return false;
}
},
openEditPage: function () {
if (this.selectStatus == -1 && this.selectStartTime != null && this.selectEndTime!=null) {
this.$router.push({
path: '/shop/'+this.$route.params.shopId+'/room/'+this.$route.params.roomId+'/price/edit?startTime='+this.selectStartTime+'&endTime='+this.selectEndTime
})
} else {
console.log('无效的点击',this.selectStatus, this.selectStartTime, this.selectEndTime!=null)
}
},
initPriceForCalender: function () {
let shopId = this.$route.params.shopId
let roomId = this.$route.params.roomId
let uri = '/v1/shop/'+shopId+'/room/'+roomId+'/price'
let _this = this;
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {


for (let i = 0; i < _this.calendarData.length; i++) {
for (let j = 0; j < _this.calendarData[i].days.length; j++) {
if (response.data.data[_this.calendarData[i].year+'-'+_this.calendarData[i].month][_this.calendarData[i].year+'-'+_this.calendarData[i].month+'-'+_this.calendarData[i].days[j].date] != undefined) {
_this.calendarData[i].days[j].price = response.data.data[_this.calendarData[i].year+'-'+_this.calendarData[i].month][_this.calendarData[i].year+'-'+_this.calendarData[i].month+'-'+_this.calendarData[i].days[j].date].price
_this.calendarData[i].days[j].flag = response.data.data[_this.calendarData[i].year+'-'+_this.calendarData[i].month][_this.calendarData[i].year+'-'+_this.calendarData[i].month+'-'+_this.calendarData[i].days[j].date].flag



}
}
}
}).catch(function (response) {
console.log(response);
});
},
initRoomBaseInfo: function () {
let shopId = this.$route.params.shopId
let roomId = this.$route.params.roomId
let uri = '/v1/shop/'+shopId+'/room/'+roomId+'/base/info'
let _this = this;
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {


_this.roomBaseInfo = response.data.data
}).catch(function (response) {
console.log(response);
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/price/Detail.vue